<template>
  <div class="top-menu">
    <div style="display:flex;align-items: center;height: 100%;"><img
        src="/newlogo.png"
        style="width: 30px; height: 30px;margin-right: 10px;background-color: white;border-radius: 50%;cursor: pointer;" @click="openTerracode">
      <div class="title">工具箱</div>
    </div>
    <div class="menu-items">
      <button @click="goLogin()">管理员登录</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TopMenuView',
  data() {
    return {
    }
  },
  methods: {
    goLogin() {
      /** 已登录缓存标记（登录页写入 sessionStorage.s） */
      const isLogin = sessionStorage.getItem('s') === 'true'
      const role = sessionStorage.getItem('role')

      if (isLogin) {
        if (role === '寻宠管理员') {
          this.$router.replace('/pet')
          return
        }
        if (role === '邑学宝管理员') {
          this.$router.replace('/yxb')
          return
        }
        if (role === '韶小助管理员') {
          this.$router.replace('/sxz')
          return
        }
        if (role === '管理员') {
          this.$router.replace('/admin')
          return
        }
      }
      this.$router.replace('/login')
    },
    openTerracode() {
      window.open('http://terracode.cn', '_blank');
    }

  }
}
</script>

<style scoped>
.title {
  font-size: 1.8rem;
  font-weight: bold;
}

.top-menu {
  background-color: #2c3e50;
  color: white;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-items button {
  background: none;
  border: none;
  color: white;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1rem;
}

.menu-items button:hover {
  text-decoration: underline;
}
</style>